// extracted by mini-css-extract-plugin
export default {"link":"NavLink_link__nYjRS","active":"NavLink_active__d6EkY"};